import { render } from "./TransportBoxCarRequisiteCreateEditDialog.vue?vue&type=template&id=6c5b8e9c&scoped=true&ts=true"
import script from "./TransportBoxCarRequisiteCreateEditDialog.vue?vue&type=script&lang=ts"
export * from "./TransportBoxCarRequisiteCreateEditDialog.vue?vue&type=script&lang=ts"

import "./TransportBoxCarRequisiteCreateEditDialog.vue?vue&type=style&index=0&id=6c5b8e9c&scoped=true&lang=css"

import exportComponent from "D:\\Work\\АСУП\\OptiLoadingPaper\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c5b8e9c"]])

export default __exports__